module.exports = __webpack_public_path__ + "static/media/people1.cf0eac4f.jpg";